import { gql } from '@apollo/client';

export const FETCH_UTILITY_ACCOUNT = gql`
  query Flex_FetchUtilityAccount($utilityAccountId: Int!) {
    utilityAccount(id: $utilityAccountId) {
      id
      accountNumber
      serviceAddressStreetOne
      serviceAddressCity
      serviceAddressState
      serviceAddressZip
    }
  }
`;
